module.exports = __webpack_public_path__ + "static/media/pad.719609d4.svg";